import React from 'react';
import { useTranslation } from 'react-i18next';

const INVOZIO_SIGNER_NAME = 'Didrik Selder';

const getTodayDate = () => new Date().toISOString().split('T')[0];

interface InvozioSignatureProps {
  employerDate?: string;
  employerSignatureDataUrl?: string | null;
  employerNameClarification?: string;
}

export const InvozioSignature: React.FC<InvozioSignatureProps> = () => {
  const { t } = useTranslation();

  return (
    <div className="ec-signature-panel ec-signature-panel--invozio">
      <h4 className="ec-signature-panel-title">
        {t('ON_BEHALF_OF_INVOZIO') || 'On behalf of Invozio LV SIA:'}
      </h4>

      <div className="ec-field-group">
        <label className="ec-field-label">{t('DATE') || 'Date'}</label>
        <input className="ec-field-input" value={getTodayDate()} disabled readOnly />
      </div>

      <div className="ec-field-group">
        <label className="ec-field-label">{t('SIGNATURE') || 'Signature'}</label>
        <div className="ec-signature-canvas-wrapper">
          <div className="ec-invozio-presigned-display">
            <img
              src="/assets/png/Didriks signatur.png"
              alt={`${INVOZIO_SIGNER_NAME} signature`}
              className="ec-invozio-presigned-img"
            />
            <div className="ec-invozio-presigned-name">
              {INVOZIO_SIGNER_NAME}, {t('INVOZIO_SIGNER_TITLE') || 'HR-chef'}
            </div>
            <div className="ec-invozio-presigned-badge">
              <span className="ec-invozio-signature-badge-icon">&#10003;</span>
              {t('DIGITALLY_PRE_SIGNED') || 'Digitally pre-signed'}
            </div>
          </div>
        </div>
      </div>

      <div className="ec-field-group">
        <label className="ec-field-label">{t('NAME_CLARIFICATION') || 'Name Clarification'}</label>
        <input
          className="ec-field-input"
          value={`${INVOZIO_SIGNER_NAME}, ${t('INVOZIO_SIGNER_TITLE') || 'HR-chef'}`}
          disabled
          readOnly
        />
      </div>
    </div>
  );
};
